import { avatarOptions, setter } from './avatar.model';
import { AvatarTemplate } from './avatar.template';

export class Avatar {
	constructor(props) {
		setter({
			id: props.id,
			img: props.img,
			size: props.size,
			altText: props.altText,
			title: props.title,
		});

		this.html = AvatarTemplate(avatarOptions);
	}

	render() {
		return this.html;
	}
}
